var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 9.6a3.19 3.19 0 0 0-2.41 1.1L6.328 8.67a3.216 3.216 0 0 0 0-1.34l4.06-2.03A3.19 3.19 0 0 0 12.8 6.4a3.2 3.2 0 1 0-3.129-2.53L5.611 5.9A3.19 3.19 0 0 0 3.2 4.8a3.2 3.2 0 0 0 0 6.4 3.19 3.19 0 0 0 2.41-1.1l4.062 2.03A3.2 3.2 0 1 0 16 12.8a3.2 3.2 0 0 0-3.2-3.2zm0-8a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2zm-9.6 8a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2zm9.6 4.8a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3c1a44aecb011f5e0d175749af64771b.svg";
export { ForwardRef as ReactComponent };